export class BulkTransactionCreateModel {

  siteId;                   // string
  completedDateTimeLt;      // date
  transactionType;          // bulkTransactionType
  vesselName;               // string
  location;                 // string
  bulk;                     // string
  quantity;                 // number
  qtyUom;                   // string
  bulkDeliveryNoteNumber;   // string
  comments;                 // string
  vesselActivityId;         // string
  tankId;                   // string
  tankStatus;               // class, autocreated here
  idc;                      // number
  previousVersionId;

  constructor(
    siteId,                   // string
    completedDateTimeLt,      // date
    transactionType,          // bulkTransactionType
    vesselName,               // string
    location,                 // string
    bulk,                     // string
    quantity,                 // number
    qtyUom,                   // string
    bulkDeliveryNoteNumber,   // string
    comments,                 // string
    vesselActivityId,         // string
    tankId,                   // string
    idc                       // number
  ) {
    this.siteId = siteId;
    this.completedDateTimeLt = completedDateTimeLt;
    this.transactionType = transactionType;
    this.vesselName = vesselName;
    this.location = location;
    this.bulk = bulk;
    this.quantity = quantity;
    this.qtyUom = qtyUom;
    this.bulkDeliveryNoteNumber = bulkDeliveryNoteNumber;
    this.comments = comments;
    this.vesselActivityId = vesselActivityId;
    this.tankId = tankId;
    this.idc = idc;

    this.buildTankStatus();
  }


  buildTankStatus() {

    // 1. Build our tank status (without qtyOnBoard)
    // 2. ? Somehow magic it into existance

    const result = new BulkTransactionTankStatusCreateModel(
      this.completedDateTimeLt,
      this.tankId,
      this.bulk,
      this.vesselName,
      getSignedQuantity(
        this.transactionType,
        this.quantity)
    );

    this.tankStatus = result;

  }

  isValid() {

    // Check for required fields
    var result = true;
    console.info(`Validating BulkTransactionCreateModel. Valid=${result}`);
    
    return result;
  }

}

export class BulkTransactionTankStatusCreateModel {

  statusDateTimeLt;       // Date, required
  tankId;                 // string, required

  bulk;                   // string, required
  vesselName;             // string, required

  specificGravity = 0;      // double, not null
  isBackload = false;       // boolean
  offshoreLocation = null;  // string
  loadDateLt = null;        // string
  dishargeDateLt = null;    // string
  wellNumber = null;        // string
  remarks = null;           // string

  quantityTransfered;       // double, required in this instance
  quantityOnBoard = 0;      // double, needs to be calculated externally

  constructor(
    statusDateTimeLt,
    tankId,
    bulk,
    vesselName,
    quantityTransfered
  ) {

    this.statusDateTimeLt = statusDateTimeLt;
    this.tankId = tankId;

    this.bulk = bulk;
    this.vesselName = vesselName;

    this.quantityTransfered = quantityTransfered;
  }

  setOptionalMeta() {
    // All the other non-required props
  }

  calculateQuantityOnBoard() {
    // Dunno how this will work yet
  }

}

const getSignedQuantity = (transactionType, quantity) => {

  if (!transactionType || typeof transactionType !== "string")
    throw "Transaction Type is not valid";

  console.log(transactionType);

  switch (transactionType.toLowerCase()) {
    case "loaded":
    case "generated":
      return parseFloat(quantity);
    case "delivery":
    case "consumption":
    case "dumped":
      return parseFloat(-quantity);
    case "notset":
    default:
      return null;
  }

}
